import { FaComments } from "react-icons/fa6";
import { FiPhone } from "react-icons/fi";

import { twMerge } from "tailwind-merge";

import { useGlobalState } from "hooks/useGlobalState";

export default function UnverifiedPhoneNumber() {
  const [_, setShowModalGlobal] = useGlobalState("mfaGlobalShow");

  return (
    <div className="flex flex-col items-center justify-center gap-4 text-center p-[48px]">
      <FaComments className="text-[72px] text-smart-teal/50" />

      <div className="flex flex-col gap-2">
        <h2 className="m-0 text-[18px] font-semibold leading-snug text-gray-900">
          Verify your phone number
        </h2>
        <p className="m-0 text-sm leading-relaxed text-gray-500 max-w-[300px]">
          Verify your phone number to access Smartkarma discussions and join the
          conversation.
        </p>
      </div>

      <button
        className={twMerge(
          "flex items-center gap-2 rounded-full border border-solid border-light-gray",
          "bg-white px-6 py-3 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 hover:border-gray-300"
        )}
        onClick={() => setShowModalGlobal(true)}
      >
        <FiPhone className="text-base" />
        Verify phone number
      </button>
    </div>
  );
}
